import apiAxios from "../api/api";

export const getMenu = async () => {
    try {
        const res = await apiAxios.get('/menu/list');
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const getUserInfo = async (id) => {
    try {
        const res = await apiAxios.get(`/user/info/${id}`);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const editUserInfo = async (id, data) => {
    try {
        const res = await apiAxios.post(`/user/edit/${id}`, data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const changePassword = async (id, data) => {
    try {
        const res = await apiAxios.post(`/user/change-password/${id}`, data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const getDocs = async (filter) => {
    try {
        const res = await apiAxios.post('/doc/getdocs', filter);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const getDoc = async (id) => {
    try {
        const res = await apiAxios.get(`/doc/getdoc/${id}`);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}